var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.wrapComponent,{tag:"component",attrs:{"to":_vm.memberRoute,"target":"_blank"}},[(_vm.row.name != _vm.row.email)?_c('div',[_vm._v(_vm._s(_vm.row.name))]):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.row.email))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }